import { Regions, RegionsCode } from '../constants/region';

export const getLocalCurrencyById = (id: RegionsCode | undefined) => {
  switch (id) {
    default:
      return 'USD';
    case RegionsCode.HK:
      return 'HKD';
    case RegionsCode.CN:
      return 'CNY';
    case RegionsCode.TW:
      return 'TWD';
    case RegionsCode.MO:
      return 'HKD';
  }
};

export const isValidRegionCode = (id: string) => {
  return Object.keys(RegionsCode).includes(id);
};

export function getCountryCodesById(id: string | undefined) {
  if (
    !Object.values(RegionsCode).includes(id as RegionsCode) &&
    id !== 'worldwide'
  ) {
    throw new Error(`${id} is not a valid RegionsCode or "worldwide"`);
  }

  const region = Regions.find((_region) => _region.id === id);
  return region ? region.countryCodes : null;
}
